import styled from "@emotion/styled";
import colors from "../../styles/colors";
export const AlertContainer = styled.div `
  display: flex;
  justify-content: space-between;
  gap: 0.25rem;
`;
export const IconContainer = styled.span `
  margin-right: 0.25rem;
`;
export const IconTextContainer = styled.div `
  display: flex;
  align-items: self-start;
  justify-content: center;
  flex-grow: 0;
  margin-top: -2px;
  svg {
    path {
      fill: ${(props) => colors[props.type === "warning" ? "color-gold-100" : "color-red-160"]}};
    }
  }
`;
export const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: self-start;
  font-family: Inter;
  font-size: 0.75rem;
  font-style: normal;
  line-height: 1.125rem;

  button {
    padding: 0;
    :active,
    :focus {
      div {
        color: ${colors["color-blue-160"]};
      }
    }
    :disabled,
    :disabled:hover {
      div {
        color: ${colors["color-gray-100"]} !important;
      }
    }
  }
`;
export const Content = styled.span `
  font-weight: 400;
  margin: 0;
`;
export const HyperLink = styled.span `
  font-weight: 600;
  margin: 0;
  color: ${colors["color-blue-120"]};
  cursor: pointer;
  &:hover {
    color: ${colors["color-blue-160"]};
  }
`;
//# sourceMappingURL=AlertMessage.styled.js.map